import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// @mui
import { styled, alpha } from '@mui/material/styles';
import { Box, Link, Button, Drawer, Typography, Avatar, Stack } from '@mui/material';
// mock
import account from '../../../_mock/account';
// hooks
import useResponsive from '../../../hooks/useResponsive';
// components
import Logo from '../../../components/logo';
import Scrollbar from '../../../components/scrollbar';
import NavSection from '../../../components/nav-section';
//
import navConfig from './config';

// ----------------------------------------------------------------------

const NAV_WIDTH = 280;

const StyledAccount = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: alpha(theme.palette.grey[500], 0.12),
}));

// ----------------------------------------------------------------------

Nav.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};

import { useSelector,useDispatch } from 'react-redux';
import { setMenueCollapsed } from 'src/redux/slices/appStateSlice';
import { logout } from 'src/redux/slices/userSlice';

import JackpotRedeem from 'src/pages/jackpot/JackpotRedeem';
import { DateTimePicker } from '@mui/lab';

export default function Nav({ openNav, onCloseNav }) {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  
  const cola = useSelector(state=>state.appState.menu_collapsed);
  const user = useSelector(state=>state.auth.user);
  
  const isDesktop = useResponsive('up', 'lg');

  const getReleaseDate = () => {
    const buildDate = process.env.REACT_APP_RELEASE_DATE;
    
    return buildDate ? buildDate : 'Unknown Release Date';
  
  };

  const releaseDate = getReleaseDate();
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    if (openNav) {
      //onCloseNav();
    }
    
  }, [pathname]);

  const handleLogout = () =>{
    dispatch(logout());
  }

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column' },
      }}
    >
      <Box sx={{ px: 2.5, py: 3, display: 'inline-flex' }}>
        <Logo />
      </Box>

      <Box sx={{ mb: 5, mx: 2.5 }}>
        <Link underline="none">
          <StyledAccount>
            <Avatar src={account.photoURL} alt="photoURL" />

            <Box sx={{ ml: 2 }}>
              <Typography variant="subtitle2" sx={{ color: 'text.primary' }}>
                {/* {account.displayName} */}
                {user?.userName}
              </Typography>

              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {user?.role}
              </Typography>
            </Box>
          </StyledAccount>
        </Link>
      </Box>

      {/* <JackpotRedeem/> */}
      <NavSection data={navConfig} />

      <Box sx={{ flexGrow: 1 }} />

     
      <Box sx={{ px: 2.5, pb: 3, mt: 10 }}>
        <Stack alignItems="center" spacing={3} sx={{ pt: 5, borderRadius: 2, position: 'relative' }}>

          <Button variant="contained" onClick={handleLogout} >
            Log Out
          </Button>
        </Stack>
        {/* Copyright and Release Date Section */}
          <Box sx={{ mt: 5, textAlign: 'center' }}>
            <Typography variant="body2" color="text.secondary">
              Copyright © {currentYear}{' '}
              <Link color="inherit" href="https://hagere-games.com/">
                hagere-games
              </Link>
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Release Date: {releaseDate}
            </Typography>
          </Box>
      </Box>
    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: (cola || !isDesktop) ? 0 : NAV_WIDTH },
      }}
    >
      {isDesktop ? (
        <Drawer
        open
          variant="permanent"
          PaperProps={{
            sx: {
              width: cola ? 0 : NAV_WIDTH,
              bgcolor: 'background.default',
              borderRightStyle: 'dashed',
            },
          }}
        >
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={openNav}
          onClose={()=>dispatch(setMenueCollapsed())}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: { width: NAV_WIDTH },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}
